/**
 * My API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface ReportLiquidsProcessedDaily { 
    date?: string;
    total_flow?: number;
    cream_flow?: number;
    skimmed_milk_flow?: number;
}

